import React, { useCallback, useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Record } from 'components'
import { Page } from 'pages'
import { Words } from 'pages'
import { CustomSection } from 'styles/GlobalStyle'
import { Button } from 'components/Form'
import { WrapFooter, WrapActionBtn, MarkingWordsStyles, MarkingWordsHeaderStyles } from './Style'
import { MarkingChat, markingWordsHooks } from '.'
import { StopMarkingWords } from '.'
import { actions } from 'store'
import { useDispatch } from 'react-redux'
import { checkingStatuses } from 'keys/checkingStatuses'
import { getTrainingWordsFetch, getWordsFetch } from 'store/middlewares/words.crud'
import { MarkingWordsAssessmentVM, WordVM } from 'models/VM'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import qc from 'keys/queryClient'
import AudioEditor from '../../../../components/Record/AudioEditor'
import AssessmentDetails from 'pages/School/Assessment/AssessmentDetails'
import { MarkingWordsContext } from './MarkingWordsContext'

const MarkingWords = () => {
    const { isAudioMarkingMode } = useContext(MarkingWordsContext)

    const { assessment } = useSelector(state => state.assessment)
    const { words } = useSelector(state => state.words)
    const { isCloseSttoper, chatWordMarkup } = useSelector(state => state.markingWords)

    const dispatch = useDispatch()
    const params = useParams()

    const isTraining = markingWordsHooks.useIsTraining()
    const startMark = markingWordsHooks.useStartMarkingWords()
    const updateAssBtns = markingWordsHooks.useUpdateAssBtns()
    const audioActionBtns = markingWordsHooks.useAudioActionBtns()
    const headerActions = markingWordsHooks.useHeaderActions()
    const actionBtns = markingWordsHooks.useActionBtns()
    const setChatMarkupState = markingWordsHooks.useChatMarkupState()
    const startMarkingAudio = markingWordsHooks.useStartMarkingAudio()

    let assessmentID = params.assessmentID
    const { assessment_def_name, assessment_def_visible_type } = assessment || {}

    const _ = useQuery({
        queryKey: [qc.assessmentAndWords, assessment?.id],
        queryFn: async ({ signal }) => {
            let assessmentData
            if (isTraining)
                assessmentData = await getTrainingWordsFetch({ signal, id: assessmentID })
            else
                assessmentData = await getWordsFetch({ signal, id: assessmentID })
            let { data } = assessmentData || {}
            const mWords = []
            data.words.forEach((word, index) => mWords.push(new WordVM({ assessment: data, ...word }, index)))

            dispatch(actions.setWords(mWords))
            let nAssessment = new MarkingWordsAssessmentVM(data, data.words)
            dispatch(actions.updateAssessment(nAssessment))
            return nAssessment
        },
    })

    useEffect(() => {
        return (() => {
            dispatch(actions.setWords(null))
            dispatch(actions.setIsCloseSttoper(true))
            setChatMarkupState(null)
        })
    }, [])

    const openChatMarkingQuestions = useCallback((word, index) => {
        if (word.marker_type != checkingStatuses.question)
            return

        setChatMarkupState(word)

        dispatch(actions.setIgnoreActions(true))
    }, [words])

    const disabledContent = isCloseSttoper

    return (
        <Page isAdminPage>
            <MarkingWordsHeaderStyles>
                <AssessmentDetails />
                <Button
                    action={startMarkingAudio}
                    className="solid-round2"
                    icon={<i class={`fa-regular ${isAudioMarkingMode ? "fa-arrow-right-from-bracket" : "fa-scissors"}`}></i>}
                    size="small"
                    label={isAudioMarkingMode ? "לצאת ממצב סימון אודיו" : "להכנס למצב סימון אודיו"}
                    color="dark"
                />
            </MarkingWordsHeaderStyles>
            <StopMarkingWords />
            <CustomSection height={210} $bg align="center">
                <AudioEditor
                    audioUrl={assessment.audio_file}
                    rate={0.75}
                    actionBtns={isAudioMarkingMode ? audioActionBtns : updateAssBtns}
                    id="StopMarkingWords"
                    // changeSetting
                    stopAudioAfterSeconds={60}
                    isAudioMarkingMode={isAudioMarkingMode}
                    showTimeline
                    showSettingsBtns
                />
            </CustomSection>
            <MarkingWordsStyles>
                <div className='words-and-buttons'>
                    <Words
                        wordAction={openChatMarkingQuestions}
                        isSystem
                        overflow={true}
                        disabled={disabledContent}
                        customHeader={{
                            left: null,
                            center: startMark,
                            right: headerActions
                        }}
                        type={assessment_def_visible_type}
                        settings={{
                            markOption: true
                        }}
                        name={assessment_def_name}
                        words={words}
                        headerActions={headerActions}
                    />
                    {words &&
                        <WrapFooter $disabled={disabledContent}>
                            {actionBtns.map((actionBtn, index) =>
                                <WrapActionBtn key={index} width={actionBtn.width}>
                                    <Button {...actionBtn} fullWidth />
                                </WrapActionBtn>
                            )}
                        </WrapFooter>
                    }
                </div>
                {chatWordMarkup &&
                    <MarkingChat disabled={disabledContent} word={chatWordMarkup} onClose={() => setChatMarkupState(false)} />}
            </MarkingWordsStyles>
        </Page>
    )
}

export default MarkingWords